export default "__VITE_ASSET__4pObplRg__"